'use strict';

import React from 'react';
import flux from 'utils/flux';
import classnames from 'classnames';
import AltContainer from 'alt-container';
import MediaListingItemNotification from './mediaListingItemNotification';
import MediaListingItemInfo from './mediaListingItemInfo';
import Thumb from 'components/thumb';

var MediaListingItem = React.createClass({

    displayName: 'MediaListingItem',

    propTypes: {
        item: React.PropTypes.object
    },

    render() {
        var item = this.props.item.toJS();

        return (
            <div className={classnames( 'listing__item', 'listing__item--' + item.type )}>

                <Thumb className="item__preview" media={this.props.item} onClickOpenModal={true}>
                    <AltContainer
                        stores={{notificationsStore: flux.getStore('notifications')}}
                        transform={({ notificationsStore }) => {
                            var notifications = notificationsStore.notifications
                                .filter((notification) => notification.mediaId === item.id);
                            return {notifications};
                        }}>
                        <MediaListingItemNotification />
                    </AltContainer>
                </Thumb>

                <MediaListingItemInfo item={this.props.item} />

            </div>
        );
    }
});

module.exports = MediaListingItem;



// WEBPACK FOOTER //
// ./app/pages/media/mediaListingItem.jsx